import { axiosInstance } from '../../api/api';
import { updateReceivePart } from './receivePart';
import { updateCurrentLineItem, updateLastLineItem } from './station';
import { getNavigableOperations } from '../../utils/operationFlow';

export const printBarcode = (
	successCallback,
	errorCallback,
	sequenceNumber,
) => {
	return () => {
		axiosInstance
			.get(`/station/label/BAR_CODE/${sequenceNumber}`)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};


export const markComplete = (
	successCallback,
	errorCallback,
	sequenceNumber,
) => {
	return (dispatch, getState) => {
		const {
			station: { currentLineItem },
			operations: { allowedOperations, currentOperation },
		} = getState();

		// Use navigable operations (excludes TAKE_IN_OUT, embedded MACHINE, etc.)
		// so the last-operation check works correctly for all station configs.
		const navigableOperations = getNavigableOperations(allowedOperations);
		const isLastOperation = currentOperation === navigableOperations[navigableOperations.length - 1];

		// Always call the API to mark the operation as complete
		axiosInstance
			.post(`/station/complete/${sequenceNumber}`)
			.then(({ data }) => {
				if (isLastOperation) {
					// If it's the last operation, clear currentLineItem and update lastLineItem
					if (currentLineItem && Object.keys(currentLineItem).length > 0) {
						dispatch(updateLastLineItem(currentLineItem));
					}
					dispatch(updateCurrentLineItem(null));
					dispatch(updateReceivePart({}));
					successCallback(data);
				} else {
					// If it's not the last operation, update completedOperations in state
					dispatch(
						updateCurrentLineItem({
							...currentLineItem,
							completedOperations: [
								...new Set([...currentLineItem.completedOperations, currentOperation]),
							],
						}),
					);
					successCallback(data);
				}
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};

/**
 * Mark station operation complete AND immediately divert the vehicle to MR.
 * Uses the same POST /station/complete/{sequenceNumber} endpoint but with
 * a { reason } body — the backend handles the MR diversion in one call.
 */
export const markCompleteAndMoveToMr = (
	sequenceNumber,
	reason,
	successCallback,
	errorCallback,
) => {
	return (dispatch, getState) => {
		const {
			station: { currentLineItem },
		} = getState();

		let actualReason = reason;
		let actualSuccess = successCallback;
		let actualError = errorCallback;

		if (typeof reason === 'function') {
			actualError = successCallback;
			actualSuccess = reason;
			actualReason = 'Defect found — sending to Major Repair for rework';
		}

		const payloadReason =
			typeof actualReason === 'string' && actualReason.trim() !== ''
				? actualReason
				: 'Defect found — sending to Major Repair for rework';

		axiosInstance
			.post(`/station/complete/${sequenceNumber}`, {
				reason: payloadReason,
			})
			.then(() => {
				// Clear station state — vehicle is now in MR, not on the line
				if (currentLineItem && Object.keys(currentLineItem).length > 0) {
					dispatch(updateLastLineItem(currentLineItem));
				}
				dispatch(updateCurrentLineItem(null));
				dispatch(updateReceivePart({}));
				if (typeof actualSuccess === 'function') {
					actualSuccess();
				}
			})
			.catch((err) => {
				if (typeof actualError === 'function') {
					actualError(err);
				}
			});
	};
};
